module.exports = __webpack_public_path__ + "img/chevron-right.312c5d28.svg";